// `Symbol.replace` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.replace
require('../internals/define-well-known-symbol')('replace');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/es.symbol.replace.js
// module id = 289
// module chunks = 1